module.exports = __webpack_public_path__ + "img/ic_sync_calendar.d6266c47.svg";